import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import messages from '../invoicingMessages';

const FilterByLockedRegistrations = ({ value, onChange }) => {
  const intl = useIntl();

  return (
    <div className="col-md-6 col-lg-4">
      <div className="form-group">
        <div
          role="group"
          aria-label="lockedRegistrations"
          className="btn-group btn-group-justified"
        >
          <button
            type="button"
            className={classNames('btn btn-default', { active: value === null })}
            onClick={() => onChange(null)}
          >
            {intl.formatMessage(messages.FilterLockedRegistrationsAll)}
          </button>
          <button
            type="button"
            className={classNames('btn btn-default', { active: value === false })}
            onClick={() => onChange(false)}
          >
            <i class="fa fa-fw fa-unlock"></i>                
            <span>{intl.formatMessage(messages.FilterLockedRegistrationsUnlocked)}</span>
          </button>
          <button
            type="button"
            className={classNames('btn btn-default', { active: value === true })}
            onClick={() => onChange(true)}
          >
            <i class="fa fa-fw fa-lock"></i>
            <span>{intl.formatMessage(messages.FilterLockedRegistrationsLocked)}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

FilterByLockedRegistrations.propTypes = {
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

FilterByLockedRegistrations.defaultProps = {
  value: null,
};

export default FilterByLockedRegistrations;
